export default __webpack_public_path__ + "static/media/detail_big_4_2.ad9d7dae.png";